import { __awaiter } from "tslib";
import { getConfig } from '@local/app-config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const bentleyIdentityBaseQuery = (args, WebApi, extraOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const bentleyIdentityBaseUrl = getConfig().bentleyBaseUrl;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: bentleyIdentityBaseUrl,
    });
    return rawBaseQuery(args, WebApi, extraOptions);
});
export const BentleyIdentityApiClient = createApi({
    reducerPath: 'bentleyIdentityAPI',
    baseQuery: bentleyIdentityBaseQuery,
    endpoints: () => ({}),
});
//# sourceMappingURL=BentleyIdentityApiClient.js.map